import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class PTC_Produtos {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaProdutos(queries = null) {
    let query = '';
    if (queries === undefined || queries === null || queries === '') {
      query = 'ptc/produtos?';
    }
    if (queries && queries.prodGrpId) {
      query = `ptc/produtos?prodGrpId=${queries.prodGrpId}`;
    }
    if (queries && queries.prodSubGrpId) {
      if (queries.prodGrpId) {
        query = `${query}&prodSubGrpId=${queries.prodSubGrpId}`;
      } else {
        query = `ptc/produtos?prodSubGrpId=${queries.prodSubGrpId}`;
      }
    }

    if (queries && queries.prodUsabId) {
      if (queries.prodGrpId || queries.prodSubGrpId) {
        query = `${query}&prodUsabId=${queries.prodUsabId}`;
      } else {
        query = `ptc/produtos?prodUsabId=${queries.prodUsabId}`;
      }
    }

    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar produtos');
    }
  }

  async filtrosList() {
    try {
      const result = await this.api.get('ptc/produtos/filtros');
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar filtros');
    }
  }
}
